import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Card } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';

const MenuItemDetail = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { getToken } = useAuth();
    const [menuItem, setMenuItem] = useState(state?.detail || null);

    useEffect(() => {
        if (!menuItem && state?.id) {
            const fetchMenuItem = async () => {
                const token = getToken();
                const res = await new WebApiCalls().getMenuItem(token, state.id);
                if (res?.code === 200) setMenuItem(res.data);
            };
            fetchMenuItem();
        }
    }, [menuItem, state, getToken]);

    if (!menuItem) return <div>Loading...</div>;

    return (
        <Row className="d-flex justify-content-center">
            <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 m-3">
                <Card>
                    <Card.Body>
                        <Card.Title className="mb-4">
                            <h4>Menu Item Details</h4>
                        </Card.Title>
                        <Row className="mb-3">
                            <Col md={6}>
                                <div className="detail-small-heading">Item Name</div>
                                <div className="detail-value">{menuItem.itemName}</div>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <div className="detail-small-heading">Type</div>
                                <div className="detail-value">{menuItem.type === 'price' ? 'Price' : 'Discount'}</div>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <div className="detail-small-heading">{menuItem.type === 'price' ? 'Price' : 'Discount'}</div>
                                <div className="detail-value">{menuItem.type === 'price' ? menuItem.price : menuItem.discountPercent}</div>
                            </Col>
                        </Row>
                        <div className="text-end mt-4">
                            <Button className="theme-cancel-btn me-3" variant="secondary" onClick={() => navigate(state?.redirect_url || '/menu-items')}>
                                Back
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default MenuItemDetail;
